import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import TaxPreparerStep from "../Wizard/steps/TaxPreparerStep.jsx";

// Standalone single-step preparer editor for the "Tax Preparers" dashboard
// page — reuses the wizard's TaxPreparerStep as-is (same fields, validation,
// and save-to-backend logic). Cancel always returns to the Tax Preparers
// list. Continue normally does too, unless we got here via ReviewStep's
// per-section "Edit" button (Wizard.jsx's editPreparer) with
// location.state.returnTo, which sends the caller back to that exact Review
// step instead of dead-ending on the preparers list.
const TaxPreparerForm = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const returnTo = location.state?.returnTo;
  const backToList = () => navigate("/dashboard/preparers");
  const afterSave = () => navigate(returnTo || "/dashboard/preparers");

  return (
    <div className="max-w-[820px] mx-auto px-[22px] py-[26px] pb-[70px]">
      <TaxPreparerStep
        onNext={afterSave}
        onDashboard={backToList}
        continueLabel="Save preparer →"
        backLabel="Cancel"
      />
    </div>
  );
};

export default TaxPreparerForm;
